import React from 'react';
import CheckCircleIcon from './CheckCircleIcon';

type Props = {
  width: number;
  height: number;
  color: string;
  iconCheck?: boolean;
  iconWarning?: boolean;
};

const ObservationIcon: React.FC<Props> = (
  { width, height, color, iconCheck, iconWarning },
  props,
) => (
  <div style={{position:'relative'}}>
    <span style={{ marginRight: '4px', marginTop: '4px' }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM9.62028 5.08185C9.86374 4.98183 10.1368 4.98183 10.3803 5.08185C10.503 5.12944 10.6152 5.20081 10.7103 5.29185C10.893 5.48348 10.9966 5.73708 11.0003 6.00185C10.9986 6.33443 10.8317 6.64443 10.555 6.82892C10.2783 7.01341 9.92792 7.04824 9.62028 6.92185C9.49909 6.87121 9.38748 6.80018 9.29028 6.71185C9.10309 6.52313 8.99874 6.26765 9.00028 6.00185C8.9969 5.87067 9.0243 5.74053 9.08028 5.62185C9.13092 5.50066 9.20195 5.38905 9.29028 5.29185C9.38538 5.20081 9.49753 5.12944 9.62028 5.08185ZM9 9.99707C9 9.44479 9.44772 8.99707 10 8.99707C10.5523 8.99707 11 9.44479 11 9.99707V13.9971C11 14.5494 10.5523 14.9971 10 14.9971C9.44772 14.9971 9 14.5494 9 13.9971V9.99707ZM1.99854 9.99951C1.99854 14.4178 5.58026 17.9995 9.99854 17.9995C12.1203 17.9995 14.1551 17.1567 15.6554 15.6564C17.1557 14.1561 17.9985 12.1212 17.9985 9.99951C17.9985 5.58123 14.4168 1.99951 9.99854 1.99951C5.58026 1.99951 1.99854 5.58123 1.99854 9.99951Z"
          fill={color}
        />
      </svg>
    </span>

    <span style={{ marginTop: '-15px', position: 'absolute' }}>
      {iconCheck && <CheckCircleIcon width={10} height={10} color="green" />}
      {iconWarning && <IconInfoWarning />}
    </span>
  </div>
);

export const IconInfoWarning = () => (
  <svg width={12} height={12} viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM9.62028 5.08185C9.86374 4.98183 10.1368 4.98183 10.3803 5.08185C10.503 5.12944 10.6152 5.20081 10.7103 5.29185C10.893 5.48348 10.9966 5.73708 11.0003 6.00185C10.9986 6.33443 10.8317 6.64443 10.555 6.82892C10.2783 7.01341 9.92792 7.04824 9.62028 6.92185C9.49909 6.87121 9.38748 6.80018 9.29028 6.71185C9.10309 6.52313 8.99874 6.26765 9.00028 6.00185C8.9969 5.87067 9.0243 5.74053 9.08028 5.62185C9.13092 5.50066 9.20195 5.38905 9.29028 5.29185C9.38538 5.20081 9.49753 5.12944 9.62028 5.08185ZM9 9.99707C9 9.44479 9.44772 8.99707 10 8.99707C10.5523 8.99707 11 9.44479 11 9.99707V13.9971C11 14.5494 10.5523 14.9971 10 14.9971C9.44772 14.9971 9 14.5494 9 13.9971V9.99707ZM1.99854 9.99951C1.99854 14.4178 5.58026 17.9995 9.99854 17.9995C12.1203 17.9995 14.1551 17.1567 15.6554 15.6564C17.1557 14.1561 17.9985 12.1212 17.9985 9.99951C17.9985 5.58123 14.4168 1.99951 9.99854 1.99951C5.58026 1.99951 1.99854 5.58123 1.99854 9.99951Z"
      fill="red"
    />
  </svg>
);

export default ObservationIcon;
